import { render, staticRenderFns } from "./Recurrencias.vue?vue&type=template&id=5976d308&"
import script from "./Recurrencias.vue?vue&type=script&lang=js&"
export * from "./Recurrencias.vue?vue&type=script&lang=js&"
import style0 from "./Recurrencias.vue?vue&type=style&index=0&id=5976d308&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports